import { MDIIcon } from 'pages/icons/MDIIcons';
import { Dropdown } from 'react-bootstrap';
import { ExportFormat } from 'utils/ExportUtils';

interface Props {
    onExport: (format: ExportFormat) => void;
    // The format currently running, or null. Drives both the spinner and the
    // lock-out: the Google Sheet export builds a real Drive file and can run
    // for a while, and a second click would build a second one.
    exportingFormat?: ExportFormat | null;
    disabled?: boolean;
    label?: string;
    variant?: string;
    className?: string;
}

const FORMAT_LABELS: Array<{ format: ExportFormat; label: string }> = [
    { format: 'csv', label: 'to CSV' },
    { format: 'excel', label: 'to Excel' },
    { format: 'google-sheet', label: 'to Google Sheets' },
];

const ExportDropdown = ({
    onExport,
    exportingFormat = null,
    disabled = false,
    label = 'Export',
    variant = 'secondary',
    className,
}: Props) => {
    const isExporting = exportingFormat !== null;

    return (
        <Dropdown className={className}>
            <Dropdown.Toggle
                variant={variant}
                disabled={disabled || isExporting}
                className="fw-bold w-100 d-flex justify-content-center align-items-center">
                <MDIIcon
                    icon={isExporting ? 'loading' : 'cloud-upload-outline'}
                    spin={isExporting}
                    size={18}
                    className="me-2"
                />
                {exportingFormat === 'google-sheet' ? 'Building sheet…' : label}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {FORMAT_LABELS.map(({ format, label: itemLabel }) => (
                    <Dropdown.Item key={format} disabled={isExporting} onClick={() => onExport(format)}>
                        {itemLabel}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ExportDropdown;
